import React from 'react';
import { Datagrid, DateField, Filter, List, NumberField, TextField, TextInput } from 'react-admin';
import CustomReportListActions from '../../../../commonComponents/ListActions/CustomReportListActions';

const CrosswordItemsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User ID" source="user_id" />
    <TextInput label="Crossword ID" source="crossword_id" />
    <TextInput label="Level ID" source="item_id" />
  </Filter>
);

const CrosswordItemsList = (props) => (
  <List
    {...props}
    filters={<CrosswordItemsFilter />}
    sort={{ field: 'created_at', order: 'DESC' }}
    actions={<CustomReportListActions exporter />}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="user_id" label="User ID" />
      <TextField source="crossword_id" label="Crossword ID" />
      <TextField source="item_id" label="Level ID" />
      <TextField source="word" label="Found Word" />
      <NumberField source="start_row" label="Start Row" />
      <NumberField source="start_col" label="Start Column" />
      <TextField source="direction" />
      <DateField source="created_at" label="Created At" textAlign="right" headerStyle={{ textAlign: 'right' }} />
    </Datagrid>
  </List>
);

export default CrosswordItemsList;
